import { Banner, BannersState } from './types';

export const bannersSelector = (state: { banners?: BannersState }): Banner[] =>
	state.banners?.banners ?? [];
